import { PATIENT_STATUS } from "../constants";
import { PatientStatus } from "./types";

export const isPatientActive = (patientStatus?: PatientStatus) => {
  if (patientStatus === undefined) return false;
  return patientStatus === PATIENT_STATUS.active;
};
